/* eslint-disable jsdoc/check-param-names */
/* eslint-disable jsdoc/check-types */
/* eslint-disable jsdoc/require-param */
import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Button,
  Stack,
  Divider,
  Switch,
  FormControlLabel,
  Paper,
  Box,
} from "@mui/material";
import { Settings, NotificationsActive } from "@material-ui/icons";

/**
 * A component that displays a card with various quick actions that can be
 * performed on a dealer, such as viewing their ID photo, contracts, and
 * changing their password. The component also displays a button to mark the
 * dealer as inactive or delete the dealer.
 *
 * The component takes in the dealer object, the current user object, and
 * several functions as props. The functions are used to handle the various
 * actions that can be performed on the dealer.
 *
 * @param {Object} dealer - The dealer object containing all information.
 * @param {Object} currentUser - The current user object containing all information.
 * @param {Function} onChangeLeaver - Function to handle click on mark as inactive button.
 * @param {Function} onDeleteClick - Function to handle click on delete button.
 * @param {Function} onChangePasswordClick - Function to handle click on change password button.
 * @param {Function} onContractsClick - Function to handle click on contracts button.
 * @param {Function} onAlertClick - Function to handle click on send alert button.
 * @param {Function} onSuppliersClick - Function to handle click on suppliers button.
 * @param {Function} onUserTypeClick - Function to handle click on change user type button.
 */
export default function LeaderActionsCard({
  dealer,
  isLeaderBlocked,
  onIsLeaderChange,
  isLeader,
  onAlertClick,
  onSuppliersClick,
}) {
  return (
    <Card elevation={2} sx={{ borderRadius: 3 }}>
      <CardContent sx={{ p: 3 }}>
        <Typography variant="h6" sx={{ fontWeight: 600, mb: 3 }}>
          Quick Actions
        </Typography>

        <Stack spacing={2}>
          <Button
            startIcon={<Settings />}
            variant="outlined"
            fullWidth
            onClick={onSuppliersClick}
            sx={{ justifyContent: "flex-start", borderRadius: 2 }}
          >
            Suppliers & Product Types
          </Button>

          <Button
            startIcon={<NotificationsActive />}
            variant="outlined"
            fullWidth
            onClick={onAlertClick}
            sx={{ justifyContent: "flex-start", borderRadius: 2 }}
          >
            Send Alert
          </Button>
          <Divider />
          <Paper
            elevation={0}
            sx={{ p: 2, bgcolor: "grey.50", borderRadius: 2 }}
          >
            <FormControlLabel
              control={
                <Switch
                  disabled={isLeaderBlocked || isLeader}
                  checked={isLeader}
                  onChange={onIsLeaderChange}
                  color="primary"
                />
              }
              label={
                <Box>
                  <Typography variant="body2" sx={{ fontWeight: 500 }}>
                    Trainer Status
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {isLeader && dealer.is_leader
                      ? `Trainer since ${dealer.is_leader_date}`
                      : "Not a Trainer"}
                  </Typography>
                </Box>
              }
            />
          </Paper>
        </Stack>
      </CardContent>
    </Card>
  );
}
